import { render, staticRenderFns } from "./WebViewer.vue?vue&type=template&id=efc938d6&scoped=true"
import script from "./WebViewer.vue?vue&type=script&lang=js"
export * from "./WebViewer.vue?vue&type=script&lang=js"
import style0 from "./WebViewer.vue?vue&type=style&index=0&id=efc938d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efc938d6",
  null
  
)

export default component.exports